module.exports = __webpack_public_path__ + "img/blindreceived.38d4b5d2.png";